import { FETCH_DASHBOARD_START, FETCH_DASHBOARD_SUCCESS, FETCH_DASHBOARD_ERROR, FETCH_DASHBOARD_MODALITY_COUNTS_ERROR, FETCH_DASHBOARD_MODALITY_COUNTS_SUCCESS } from '../actions/dashboardActions';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    dashboard: {},
    modalityDahsboard: []
}
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_DASHBOARD_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_DASHBOARD_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, dashboard: { ...action.dashboard } };
        }
        case FETCH_DASHBOARD_ERROR: {
            return { ...state, error: '', message: '', loading: false };
        }
        case FETCH_DASHBOARD_MODALITY_COUNTS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, modalityDahsboard: [...action.modalityDahsboard] };
        }
        case FETCH_DASHBOARD_MODALITY_COUNTS_ERROR: {
            return { ...state, error: '', message: '', loading: false, modalityDahsboard: [] };
        }
        default:
            return state;
    }
}